/**
 * Marks the transparent header while the hero is still behind it.
 *
 * The theme sets `transparent` on header-component for the whole template, not
 * just for the stretch where media sits behind the header - it never drops the
 * attribute on scroll. On the home page that means the header keeps its
 * over-media treatment all the way down, which is why the white logo image goes
 * invisible against the white sections below the hero. Painting the icons white
 * (the point of this file, see .gb-header--over-hero in gb-custom.css) would put
 * them in the same hole.
 *
 * So: add the class while any part of the first section is below the header's
 * bottom edge, remove it once that section has scrolled past. The CSS paints
 * white under the class and falls back to the theme's dark icons plus the
 * inverse (dark) logo without it.
 */
(() => {
  const header = document.querySelector('header-component[transparent]');
  if (!header) return;

  const hero = document.querySelector('#MainContent > .shopify-section');
  if (!hero) return;

  // the page scrolls .page-wrapper, not the document, so that is the observer root
  const scroller = document.querySelector('.page-wrapper');
  const topRow = header.querySelector('.header__row--top') || header;

  const OVER_HERO = 'gb-header--over-hero';

  // Start in the over-hero state: at the top of the page it is always correct,
  // and it avoids a dark-to-light flash before the observer's first callback.
  header.classList.add(OVER_HERO);

  let observer = null;

  const observe = () => {
    if (observer) observer.disconnect();
    const headerHeight = Math.round(topRow.getBoundingClientRect().height) || 68;
    observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          header.classList.toggle(OVER_HERO, entry.isIntersecting);
        }
      },
      {
        root: scroller || null,
        // pull the top edge down to the header's underside, so the hero stops
        // "intersecting" exactly when it stops passing behind the header
        rootMargin: `-${headerHeight}px 0px 0px 0px`,
        threshold: 0,
      }
    );
    observer.observe(hero);
  };

  observe();

  // the header shrinks/grows with the viewport, which moves the boundary
  let resizeTimer = null;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(observe, 150);
  });
})();
